export default "__VITE_ASSET__BTInCJOk__"